import { IGetGeoByAddressParams, TGetGeoByAddressData, TGetGeoByAddressResult } from './types';
import { mapResponse200, mapResponse400 } from './utils';
import { fetchAddformGeocode, IMappers } from '../../repositories/monolith-python/v2/geocode';

export async function getGeoByAddress(params: IGetGeoByAddressParams): Promise<TGetGeoByAddressResult> {
  const { httpApi, category, userInput: request } = params;

  const parameters = {
    request,
    category,
    checkLocality: false,
  };

  const mappers: IMappers<TGetGeoByAddressData, null> = {
    200: mapResponse200,
    400: mapResponse400,
  };

  try {
    const result = await fetchAddformGeocode({ httpApi, parameters, mappers });

    return result as TGetGeoByAddressResult;
  } catch (error) {
    return null;
  }
}
